<template>
  <v-layout wrap
    align-center
    justify-start
    class="oct-toolbar control-toolbar tertiary">
    <v-flex shrink>
      <h2 :class=colorClass>{{name}}</h2>
    </v-flex>
    <v-flex shrink>
      <select-with-button
        :value="selectedDropdownItem"
        @change="selectExam"
        :items="dropdownItems"
        item-value="flSrNo"
        :icon-button="true"
        item-text="octDateButtonText"
        class="toolbar-select"/>
    </v-flex>
  </v-layout>
</template>

<script>
import selectWithButton from "../../controls/SelectWithButton";
import { mapGetters } from "vuex";
export default {
  name: "cirrusComparisonToolbar",
  components: { selectWithButton },
  props: {
    name: String,
    context: Object,
    exams: Array,
    groups: Array
  },
  computed: {
    ...mapGetters([
      "compare",
      "compare_dropdownItems",
      "compare_selectedDropdownItem",
      "baseline",
      "baseline_dropdownItems",
      "baseline_selectedDropdownItem"
    ])
  },
  data() {
    return {
      dropdownItems:[],
      selectedDropdownItem: null
    };
  },
  methods: {
    selectExam(flSrNo) {
      this.$store.dispatch("selectOCTExamCompareWithDropdown", flSrNo);
    },
  },
  watch: {
    context(){
      this.dropdownItems.length = 0;
      this.context.exams = this.exams;
      this.context.generateOCTDropdown();
    },
    compare_dropdownItems() {
      if (this.compare && this.context.view == "compare") 
        this.dropdownItems = this.context.dropdownItems;
    },
    
    compare_selectedDropdownItem() {
      if (this.compare && this.context.view == "compare") 
        this.selectedDropdownItem = this.context.selectedDropdownItem;
    },
    
    baseline_dropdownItems() {
      if (this.baseline && this.context.view == "baseline") 
        this.dropdownItems = this.context.dropdownItems;
    },
    
    baseline_selectedDropdownItem() {
      if (this.baseline && this.context.view == "baseline") 
        this.selectedDropdownItem = this.context.selectedDropdownItem;
    }
  },
  mounted(){
      this.context.exams = this.exams;
      this.context.generateOCTDropdown();
  }
}
</script>